import { useQuery } from '@tanstack/react-query';

import { environmentDetailsQuery } from './environment-details-query';

export type EnvironmentDetails = {
  Pos4Url?: string;
  Pos3Url?: string;
  BackOfficeUrl?: string;
  CurbsideUrl?: string;
  MobileCheckoutUrl?: string;
  DutchieBohUrl?: string;
  DutchieRegisterUrl?: string;
  LaunchDarklyClientKey?: string;
  Region?: string;
  LaunchDarklyRelayPos?: string | null;
  UseLaunchDarklyRelayForEvents?: boolean;
};

export type EnvironmentDetailsApiResult = {
  Result: boolean;
  Message?: string;
  Data: EnvironmentDetails;
};

export function useEnvironmentDetailsQuery() {
  return useQuery({
    queryKey: ['/api/admin/environment-details'],
    queryFn: async () => {
      return await environmentDetailsQuery();
    },
  });
}
